import { FancyCheckmark } from "common/FancyCheckmark";
import { ConfirmationDialog } from "common/styleguide/ConfirmationDialog";
import { apiv3 } from "lib/apiv3";
import { errorMessage } from "lib/styleguide/base.scss";
import React from "react";
import { withRouter } from "react-router-dom";
import styles from "./CopyExperienceDialog.scss";

export const COPY_EXPERIENCE_DIALOG = "COPY_EXPERIENCE_DIALOG";

class _CopyExperienceDialog extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      copyPending: false,
      copyError: false,
      copyAllRoutes: false,
      copiedExperience: null,
    };
  }

  onConfirm = () => {
    const { experienceId } = this.props;
    const { copyAllRoutes } = this.state;

    this.setState({ copyPending: true });
    apiv3.experiences
      .copy(experienceId, { copyAllRoutes })
      .then(({ experience }) => {
        this.setState({ copiedExperience: experience });
      })
      .catch(() => this.setState({ copyPending: false, copyError: true }));
  };

  goToCopy = () => {
    const { history, onRequestClose } = this.props;
    history.push(`/experiences/${this.state.copiedExperience.id}/edit`);
    onRequestClose();
  };

  render() {
    const { onRequestClose } = this.props;
    const { copyPending, copyError, copyAllRoutes, copiedExperience } = this.state;

    if (!copiedExperience) {
      return (
        <ConfirmationDialog
          confirmText="Copy Experience"
          onRequestClose={onRequestClose}
          onCancel={onRequestClose}
          onConfirm={this.onConfirm}
          confirmPending={copyPending}
        >
          Make a copy of all your detail and guide content. If you would like to create new versions of the routes,
          check the box below.
          <div className={styles.form}>
            <label>
              <input
                type="checkbox"
                className={styles.checkbox}
                onChange={(e) => this.setState({ copyAllRoutes: e.target.checked })}
                checked={copyAllRoutes}
              />
              Make new versions of all the routes in the Experience
            </label>
          </div>
          {copyError && (
            <div className={errorMessage}>
              Oops, we encountered an error while copying this Experience. Please try again.
            </div>
          )}
        </ConfirmationDialog>
      );
    } else {
      return (
        <ConfirmationDialog
          confirmText="Go to Copy"
          cancelText="Close"
          onRequestClose={onRequestClose}
          onCancel={onRequestClose}
          onConfirm={this.goToCopy}
        >
          <FancyCheckmark />
          <div style={{ marginTop: "20px", textAlign: "center" }}>Successfully copied Experience.</div>
        </ConfirmationDialog>
      );
    }
  }
}

export const CopyExperienceDialog = withRouter(_CopyExperienceDialog);
